import { render, staticRenderFns } from "./mpModal.vue?vue&type=template&id=46b78049"
import script from "./mpModal.vue?vue&type=script&lang=js"
export * from "./mpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports